import { createSlice } from 'utils/@reduxjs/toolkit';
import { PriceState } from './types';
import { reducers } from './reducers';

export const initialState: PriceState = {
  isLoading: false,
  data: {
    items: [],
  },
  error: null,
};

const slice = createSlice({
  name: 'price',
  initialState,
  reducers,
});

export const { actions: priceActions } = slice;
export const { reducer: priceReducer } = slice;
